import ApplicanForm from '../ApplicantForm/ApplicantForm';
import { CreditApplicationType } from '../../../../utils/enums/financialTypes.enum';
import FormSectionPage from '../../ui/formSectionPage';
import { useLocalization } from '../../../../utils/useLocalization';
import { state as initialState, JointAppContext } from './context';
import React, { useEffect, useState } from 'react';
import './style.scss';

export interface IApplicantInfo {
    applicationType: string;
    applicantData: any;
    setApplicantData: Function;
    coapplicantData: any;
    setCoapplicantData: Function;
    setApplicantValid: Function;
    isOpen: boolean;
    setOpen: Function;
    isBlocked?: boolean;
    initialJointOrCoApplicant?: any;
    initialJointOrCoAppRelationship?: any;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

const CERO = 0;

const ApplicantInfo: React.FC<IApplicantInfo> = ({
    applicationType,
    applicantData,
    setApplicantData,
    coapplicantData,
    setCoapplicantData,
    setApplicantValid,
    isOpen,
    setOpen,
    isBlocked = false,
    initialJointOrCoApplicant = null,
    initialJointOrCoAppRelationship = null,
    isEditMode = false,
    disablePrintAndSubmitBtn,
}) => {
    const { businessComercial } = useLocalization();
    const [disabledForm, setDisabledForm] = useState<boolean>(false);
    //const [isOpen, setOpen] = useState<boolean>(false);
    const [showicon, setShowIcon] = useState<boolean | null>(null);
    const [applicantSubmit, setApplicantSubmit] = useState<any>(null);
    const [coApplicantSubmit] = useState<any>(null);
    const [isCoAppFieldValueUpdated, setIsCoAppFieldValueUpdated] =
        useState<boolean>(false);

    const changeApplicant = (handler: any) => {
        setApplicantSubmit(handler);
    };

    function handleSubmit() {
        if (applicantSubmit) {
            applicantSubmit.validate();
        }
        if (
            applicationType.includes(CreditApplicationType.JOINT) ||
            applicationType.includes(CreditApplicationType.COAPP)
        ) {
            if (coApplicantSubmit) {
                coApplicantSubmit.validate();
            }
        }
    }

    useEffect(() => {
        if (isEditMode && !isCoAppFieldValueUpdated) {
            return;
        }
        let isSectionValid = false;
        if (applicantSubmit) {
            if (Object.keys(coapplicantData).length > CERO) {
                isSectionValid = true;
            }

            if (isSectionValid) {
                if (!isEditMode || (isEditMode && isOpen)) {
                    setShowIcon(true);
                    setOpen(false);
                    setDisabledForm(true);
                    setApplicantValid(true);
                }
            } else {
                setShowIcon(false);
                setOpen(true);
                setDisabledForm(false);
                setApplicantValid(false);
            }
        }
    }, [applicantData, coapplicantData]);

    useEffect(() => {
        if (showicon === true) setOpen(false);
        else if (showicon === false) {
            setOpen(true);
            setShowIcon(false);
        }
    }, [showicon]);

    const onEdit = () => {
        setApplicantValid(false);
        setDisabledForm(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };

    return (
        <FormSectionPage
            title={
                applicationType === CreditApplicationType.BUSINESS_COAPP
                    ? businessComercial.CO_APP_INFO
                    : businessComercial.GUARANTOR_APP_INFO
            }
            handlerSubmit={handleSubmit}
            isOpen={isOpen}
            setOpen={setOpen}
            showIcon={showicon}
            isDisabled={disabledForm}
            onEdit={onEdit}
            isEditMode={isEditMode}
            isBlocked={isBlocked}
            disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
        >
            <fieldset disabled={disabledForm} className={'applicant-info'}>
                <JointAppContext.Provider value={initialState}>
                    <ApplicanForm
                        key={'Applicant'}
                        applicationType={applicationType}
                        handlerUpdate={changeApplicant}
                        isDisabled={disabledForm}
                        setApplicantData={setApplicantData}
                        setCoapplicantData={setCoapplicantData}
                        isCoApplicant={true}
                        initialPrimaryApplicant={initialJointOrCoApplicant}
                        initialJointOrCoAppRelationship={
                            initialJointOrCoAppRelationship
                        }
                        isEditMode={isEditMode}
                        isFieldValueUpdated={isCoAppFieldValueUpdated}
                        setIsFieldValueUpdated={setIsCoAppFieldValueUpdated}
                    />
                </JointAppContext.Provider>
            </fieldset>
        </FormSectionPage>
    );
};

export default ApplicantInfo;
